import { MaskedRange } from 'imask';
import { DateValue } from 'imask/esm/masked/date';

const minYear = 2000;
const maxYear = 2099;

export const dateMask = () => {
  return {
    mask: Date,
    pattern: 'Y-m-d',
    blocks: {
      d: {
        mask: MaskedRange,
        from: 1,
        to: 31,
        maxLength: 2,
      },
      m: {
        mask: MaskedRange,
        from: 1,
        to: 12,
        maxLength: 2,
      },
      Y: {
        mask: MaskedRange,
        from: minYear,
        to: maxYear,
      },
    },
    format: (date: DateValue) => {
      if (date) {
        let day = date.getDate().toString();
        let month = (date.getMonth() + 1).toString();
        const year = date.getFullYear();
        if (date.getDate() < 10) {
          day = '0' + day;
        }
        if (date.getMonth() + 1 < 10) {
          month = '0' + month;
        }

        return [year, month, day].join('-');
      }
      return '';
    },
    parse: (str: string) => {
      const [year, month, day] = str.split('-');
      return new Date(Number(year), Number(month) - 1, Number(day));
    },
    min: new Date(minYear, 0, 1),
    max: new Date(maxYear, 11, 31),
    autofix: true,
    lazy: false,
  };
};
